import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthStore } from 'src/app/store/auth-store';
import { environment } from 'src/environment';
import { LoginRequest } from '../login-request.model';
import { MatIconModule } from '@angular/material/icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-ad-login',
    imports: [CommonModule, MatFormFieldModule, ReactiveFormsModule, MatInputModule, MatIconModule, TranslateDirective, TranslatePipe],
    templateUrl: './ad-login.component.html',
    styleUrls: ['./ad-login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: "fill", floatLabel: "always" }
        }
    ]
})
export class AdLoginComponent implements OnInit {
  @Input() formControl?: FormControl;
  
  #builder = inject(FormBuilder);

  loginForm = this.#builder.group({
    password: new FormControl<string | null>(null, [Validators.required]),
    name: new FormControl<string | null>(null, [Validators.required]),
  });

  #authStore = inject(AuthStore);
  showPassword = false;
  redirectTo!: string;

  registerOnChangeCallback: any = () => { };

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    const redirectTo = "redirectUrl";
    this.redirectTo = this.route.snapshot.queryParams[redirectTo] || "/";

    // שינויים בטופס הפנימי מעדכנים את הקומפוננטה אב
    this.loginForm.valueChanges.subscribe((formValue) => {
      this.#authStore.resetError();
      
      // עדכון ה-FormControl מהאב אם קיים
      if (this.formControl) {
        this.formControl.setValue(formValue);
        this.formControl.markAsTouched();
        if (this.loginForm.invalid) {
          this.formControl.setErrors({ invalid: true });
        } else {
          this.formControl.setErrors(null);
        }
      }
    });

    this.loginForm.controls.password.valueChanges.subscribe(() => {
      this.showPassword = false;
    });
  }
}
